<template>
    <div>
        <div class="modal-overlay active"  @click="closeDialog()"></div>
        <div class="modal">
            <div class="modal__header">
                <h2 class="headline-s">Resale Certificates</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="modal__body flex-column authorization-form">
                <rothco-table style="width: 100%;" v-model:content="gridData" :visible-fields="columnHeaders"
                :pt="{ bodyRow: 'resale-certificates-row'}" :ptOptions="{ mergeProps: true }">
                    <template v-for="(item, index) in gridData" :key="`region_${index}`" v-slot:[`region_${index}`]="slotProps">
                        <div class="text-left" style="text-wrap: auto;">{{ item.data?.region_names ?? '--' }}</div>
                    </template>
                </rothco-table>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { ref, computed, inject, } from "vue";
    import { Link } from "@inertiajs/vue3";
    import CloseIcon from "@icons/closeIcon.svg";
    import RothcoTable from "@/components/RothcoTable.vue";

    const dialogRef = inject('dialogRef');
    let route = inject('route');
    const closeDialog = () => {
        dialogRef?.value?.close({ addedUser: false});
    }

    let resaleCertificates = computed(()=>{
        return dialogRef?.value?.data?.resaleCertificates
    });

    let gridData = computed(()=>{
        return resaleCertificates.value.map(cert=>{
            return {data: cert}
        });
    });

    let columnHeaders = computed(()=>{
        return [
            {
                field: 'reseller_certificate_no',
                is_custom: false,
                label: 'Certification No.',
                pt: {
                    bodyCell: {class: 'mob-w-50', 'data-label': "Certification No."}
                },
            },
            {
                field: 'region',
                is_custom: true, 
                label: 'Region(s)',
                pt: {
                    bodyCell: {class: 'mob-w-50', 'data-label': 'Region(s)'}
                }
            },
        ];
    });
</script>
